// This is a helper that wraps the window.performance API to make it more convenient
// to measure time ranges.

'use strict';

var performance = require('./performance.js');

// Incremented for each new mark so they all have unique names.
var markIdx = 0;

function mark() {
    var name = 'phxMark:' + markIdx++;
    performance.mark(name);
    return name;
}

module.exports = function performanceMeasure(name) {
    var startMark = mark();
    return {
        end: function () {
            var endMark = mark();
            performance.measure(name, startMark, endMark);
            // Return a result in case we want to beacon it anywhere.
            let entries = performance.getEntriesByName(name);
            if (entries && entries.length) {
                return entries[entries.length - 1].duration;
            }
        },
    };
};
